import { config } from 'CONFIG';

export const requestToApp = ( func, data = {}, callback ) => {

    data = JSON.stringify( data );
    if ( config.client === 'IOS' ) {

        registerHandler( func, callback );
        window.webkit.messageHandlers[ func ].postMessage( data );
        console.log( `IOS ${func} called` );

    } else {

        if ( window.WebViewJavascriptBridge ) {

            window.WebViewJavascriptBridge.callHandler( func, data, callback );
            console.log( `Android ${func} called` );
        
        } else {

            document.addEventListener( 'WebViewJavascriptBridgeReady', function () {

                window.WebViewJavascriptBridge.callHandler( func, data, callback );
                console.log( `Android ${func} called` );
            
            });

        }

    }

};

export const registerHandler = ( name, callback ) => {

    if ( config.client === 'IOS' ) {

        window.IOSCaller[ name ] = callback;

    } else {

        window.WebViewJavascriptBridge.registerHandler( name, callback );

    }

};

export const getClient = () => {

    let ua = window.navigator.userAgent;
    if ( ua.includes( 'RCloud/Android' )) {

        return 'Android';

    } else if ( ua.includes( 'RCloud/IOS' )) {

        return 'IOS';

    } else {

        return 'Web';

    }

};

export const getToken = async () => {
    
    let appMessage = {};
    function callback ( data ) {
        
        console.log( 'get token function' );
        data = window.Json.parse( data );
        appMessage = data;
    
    }
    await requestToApp( 'getToken', {}, callback );
    return appMessage;

};

export const refreshToken = async () => {

    let appMessage = {};
    function callback ( data ) {
    
        data = window.Json.parse( data );
        appMessage = data;
    
    }
    await requestToApp( 'refreshToken', {}, callback );
    return appMessage;

};



// WEBPACK FOOTER //
// ./src/api/app.js